// Reusable Pagination component — used on all list pages

const Pagination = ({ currentPage, totalPages, onPageChange, total, limit }) => {
  if (totalPages <= 1) return null;

  const from  = (currentPage - 1) * limit + 1;
  const to    = Math.min(currentPage * limit, total);

  // Build page numbers to show: always show first, last, and 2 around current
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "24px",
      flexWrap: "wrap",
      gap: "12px",
    }}>
      {/* Showing X–Y of Z */}
      <p style={{ fontSize: "13px", color: "#a3aed0", margin: 0 }}>
        Showing <strong style={{ color: "#1b2559" }}>{from}–{to}</strong> of{" "}
        <strong style={{ color: "#1b2559" }}>{total}</strong> results
      </p>

      {/* Page buttons */}
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {/* Prev */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={btnStyle(currentPage === 1, false)}
        >
          ← Prev
        </button>

        {/* Number buttons */}
        {pages.map((p, i) =>
          p === "..." ? (
            <span key={`dots-${i}`} style={{ padding: "0 4px", color: "#a3aed0" }}>…</span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              style={btnStyle(false, p === currentPage)}
            >
              {p}
            </button>
          )
        )}

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={btnStyle(currentPage === totalPages, false)}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

const btnStyle = (disabled, active) => ({
  height: "36px",
  minWidth: "36px",
  padding: "0 12px",
  border: active ? "none" : "1px solid #e0e5f2",
  borderRadius: "10px",
  background: active ? "#4318ff" : disabled ? "#f4f7fe" : "#ffffff",
  color: active ? "#ffffff" : disabled ? "#c5cde8" : "#1b2559",
  fontWeight: active ? "700" : "500",
  fontSize: "13px",
  cursor: disabled ? "not-allowed" : "pointer",
  transition: "all 0.15s ease",
  opacity: disabled ? 0.6 : 1,
});

export default Pagination;
